import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ScheduleOutlinedSvg from "@ant-design/icons-svg/es/asn/ScheduleOutlined";
import AntdIcon from "../components/AntdIcon";
var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScheduleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ScheduleOutlined.displayName = 'ScheduleOutlined';
}
export default /*#__PURE__*/React.forwardRef(ScheduleOutlined);